module.exports = __webpack_public_path__ + "static/media/icon-folder-plus.6ab491fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/FileItem/assets/icon-folder-plus.svg
// module id = 2474
// module chunks = 193